import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { isLinearSettings } from "../../../../viewer/chart/helper.ts";
import StyleGroup from "../../../../viewer/chart/StyleGroup.tsx";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import ShowLabelItem from "./ShowLabelItem.tsx";
import Title from "./Title.tsx";

export default function ArgumentAxisStyles({ readonlyMode }: { readonlyMode: boolean }) {
  const settingsAreaValues = useSelector(selectChartSettingsState);

  const supported = isLinearSettings(settingsAreaValues);

  if (!supported) {
    return <></>;
  }

  return (
    <StyleGroup caption="Argument Axis">
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        <ShowLabelItem settings={settingsAreaValues} readonlyMode={readonlyMode} />
        <Title settings={settingsAreaValues} readonlyMode={readonlyMode} />
      </Stack>
    </StyleGroup>
  );
}
